import createDelayedAction from './createDelayedAction';
import executeQue from './executeQue';
import logout from './logout';
import navigateTo from './navigateTo';
import redirectTo from './redirectTo';
import requestTo from './requestTo';
import scrollTo from './scrollTo';
import setState from './setCustomState';
import setJWT from './setJWT';
import setThrow from './setThrow';
import shareLink from './shareLink';
import { DelayedActionFunction } from './types';

const actions: Record<string, DelayedActionFunction<any[]>> = {
  setJWT: createDelayedAction(setJWT),
  setThrow: createDelayedAction(setThrow),
  shareLink: createDelayedAction(shareLink),
  setState: createDelayedAction(setState),
  //   sendMessage: createDelayedAction(sendMessage),
  scrollTo: createDelayedAction(scrollTo),
  redirectTo: createDelayedAction(redirectTo),
  navigateTo: createDelayedAction(navigateTo),
  que: createDelayedAction(executeQue),
  request: createDelayedAction(requestTo),
  logout: createDelayedAction(logout),
  //   reconnect: createDelayedAction(reconnect),
};

export default actions;
